var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftRedIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow-7288805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right arrow",
    d: "M2.31 11.7108C2.34795 11.6216 2.40221 11.5402 2.47 11.4708L5.47 8.47082C5.61217 8.33834 5.80022 8.26622 5.99452 8.26965C6.18882 8.27308 6.37421 8.35179 6.51162 8.4892C6.64903 8.62662 6.72775 8.812 6.73117 9.0063C6.7346 9.2006 6.66248 9.38865 6.53 9.53082L4.81 11.2508H21C21.1989 11.2508 21.3897 11.3298 21.5303 11.4705C21.671 11.6111 21.75 11.8019 21.75 12.0008C21.75 12.1997 21.671 12.3905 21.5303 12.5312C21.3897 12.6718 21.1989 12.7508 21 12.7508H4.81L6.53 14.4708C6.67045 14.6114 6.74934 14.8021 6.74934 15.0008C6.74934 15.1996 6.67045 15.3902 6.53 15.5308C6.38938 15.6713 6.19875 15.7502 6 15.7502C5.80125 15.7502 5.61062 15.6713 5.47 15.5308L2.47 12.5308C2.40221 12.4615 2.34795 12.3801 2.31 12.2908C2.27037 12.1993 2.24993 12.1006 2.24993 12.0008C2.24993 11.9011 2.27037 11.8024 2.31 11.7108Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRedIcon2);
export default __webpack_public_path__ + "static/media/left-red-icon (2).a72ae48722caf7c2b4f00d9e839ee17d.svg";
export { ForwardRef as ReactComponent };